<template>
  <ul :class="[type == 1 ? 'sy_05ul' : 'sy_06ul']">
    <a v-for="item in companyList" :key="item.id" :href="'enterprise_detail.html?id='+item.id">
      <li>
        <div class="pic" :style="{
          backgroundImage: 'url('+item.logo+')',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: 'contain'}">
<!--          <img :src="item.logo" />-->
        </div>
        <div class="text">
          <div class="tit">{{item.name}}</div>
          <div class="con">{{item.brief}}</div>
        </div>
      </li>
    </a>
  </ul>
</template>

<script>
    // import api from '../api/api'
    import layer from "layui-layer";

    export default {
      name: 'companyList',
      props: ['type','searchType'],
      data: function(){
        return {
          companyList:[]
        }
      },
      watch: {
        type: function(n, o){
          console.log(n + " - " + o);
        },
        searchType: function(n, o){
          console.log(n + " - " + o);
        }
      },
      created: function(){
        console.log("companyList created, type: " + this.type + ", searchType: " + this.searchType);
        this.searchCompany();
      },
      methods: {
        searchCompany: function () {
          let param = {};
          param.size = 20;
          param.current = 1;
          let url = "/company/" + this.type;
          if(this.searchType == 1){
            url += "/hot";
          } else if(this.searchType == 2){
            url += "/new";
          }
          let _this = this;
          this.$http.post(url, param, function (re) {
            if(re.code == '000000'){
              _this.companyList = re.data.records;
            } else {
              layer.msg(re.message, {fixed: false});
            }
          }, function (re) {
              console.log("companyList.vue: " + re);
          })
        }
      }
    }
</script>
